// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Computes a deterministic hash string from billing configuration values.
 * Used to detect config drift after charge generation so the UI can warn
 * the user that their generated charges no longer match the current config.
 *
 * Only includes the price field relevant to the current pricing mode so
 * toggling mode and back produces the same hash.
 *
 * totalOverride is included because it drives the line-item total allocated
 * across generated charges. Changing it must trigger the out-of-sync indicator.
 */
export function computeConfigHash(
  pricingMode: string,
  chargeSchedule: string,
  chargeFrequency: string,
  invoiceFrequency: string,
  invoiceMode: string,
  quantity: number,
  unitPrice: number,
  fixedPrice: number,
  totalOverride: number | null,
  chargeMode: string,
  activationDate: string
): string {
  const effectivePrice =
    pricingMode === 'PER_UNIT'
      ? `u:${String(unitPrice)}`
      : `f:${String(fixedPrice)}`;
  const overrideToken =
    totalOverride !== null ? `o:${String(totalOverride)}` : 'o:';
  return [
    pricingMode,
    chargeSchedule,
    chargeFrequency,
    invoiceFrequency,
    invoiceMode,
    quantity,
    effectivePrice,
    overrideToken,
    `m:${chargeMode}`,
    `a:${activationDate}`,
  ].join('|');
}
